import React from 'react';
import PropTypes from 'prop-types';
import isHotkey from 'is-hotkey';

export { MdFormatUnderlined as UnderlineIcon } from 'react-icons/md';

export const UnderlineMark = ({ attributes, children }) => (
  <span className="underlineMark" {...attributes}>{children}</span>
);

export const UNDERLINE_MARK_TYPE = 'underline';

UnderlineMark.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const underlinePlugin = () => ({
  onKeyDown: (event, editor, next) => {
    if (isHotkey('mod+u', event)) {
      event.preventDefault();

      return editor.toggleMark(UNDERLINE_MARK_TYPE);
    }
    next();
  },
  renderMark: (props, editor, next) => {
    if (props.mark.type === UNDERLINE_MARK_TYPE) {
      return <UnderlineMark {...props} />;
    }
    return next();
  },
  commands: {
    toggleUnderline: editor => editor.toggleMark(UNDERLINE_MARK_TYPE),
  },
  serialize: (node, children) => {
    if (node.type === UNDERLINE_MARK_TYPE) {
      return <label style={{ textDecoration: 'underline' }}>{children}</label>;
    }
  },
});

export default underlinePlugin;
